export const addKeyToClipboard = (secret) => {
	const type = "text/plain"
	const clipboardItemData = {
		[type]: secret,
	}
	const clipboardItem = new ClipboardItem(clipboardItemData)
	navigator.clipboard.write([clipboardItem])
}
